
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avi-to-mp4-converter",
      function () {
        return require("private-next-pages/avi-to-mp4-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avi-to-mp4-converter"])
      });
    }
  